import styles from './AccountCard.module.scss'
import { Card } from '@boltenergy-be/design-system'
import { AccountCardProps } from './types'
import { useTranslation } from 'next-i18next/pages'
import { formatAddress } from 'utils/format'
import { CUSTOMER_TYPES } from '@boltenergy-be/shared'

const AccountCard = ({ account, onSelect, isDisabled, withAddress }: AccountCardProps) => {
  // i18n
  const { t } = useTranslation('registration')

  // Constants
  const customerType = account.company ? CUSTOMER_TYPES.professional : CUSTOMER_TYPES.residential

  return (
    <Card as="li" className={styles['account-card']}>
      <button onClick={onSelect} className={styles.info} disabled={isDisabled}>
        <strong className={styles.name}>{account.name}</strong>

        <small className={styles['customer-number']}>
          {account.customerNumber} ({t(`extraAddressModal.customerType.${customerType.toLocaleLowerCase()}`)})
        </small>

        {!!account.company && (
          <small className={styles['enterprise-number']}>
            {t('extraAddressModal.enterpriseNumber')}: {account.company.enterpriseNumber}
          </small>
        )}
        {withAddress && <address className={styles.address}>{formatAddress(account.correspondenceAddress)}</address>}
      </button>
    </Card>
  )
}

export default AccountCard
